import { useState } from "react";
import axiosInstance from "../../api/axiosInstance";

export default function ChangePasswordPage() {
  const [formData, setFormData] = useState({
    current_password: "",
    new_password: "",
    re_new_password: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    if (formData.new_password !== formData.re_new_password) {
      setError("New passwords do not match");
      setIsLoading(false);
      return;
    }

    try {
      const response = await axiosInstance.post(
        `/api/v1/auth/change-password/`,
        formData
      );

      if (response.data.message) {
        setSuccess(true);
        // Clear form
        setFormData({
          current_password: "",
          new_password: "",
          re_new_password: "",
        });
      }
    } catch (err) {
      console.error("Password change failed:", err);
      if (err.response?.data?.error) {
        setError(err.response.data.error);
      } else if (err.response?.data?.current_password) {
        setError(err.response.data.current_password[0]);
      } else if (err.response?.data?.new_password) {
        setError(err.response.data.new_password[0]);
      } else {
        setError("An error occurred while changing your password");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-medium text-gray-900">Change Password</h2>
        <p className="mt-1 text-sm text-gray-500">Update your password to keep your account secure.</p>
      </div>

      {error && (
        <div className="rounded-md bg-red-50 p-4">
          <div className="flex">
            <div className="ml-3">
              <h3 className="text-sm font-medium text-red-800">{error}</h3>
            </div>
          </div>
        </div>
      )}

      {success && (
        <div className="rounded-md bg-green-50 p-4">
          <div className="flex">
            <div className="ml-3">
              <h3 className="text-sm font-medium text-green-800">
                Password changed successfully!
              </h3>
            </div>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="current_password" className="block text-sm font-medium text-gray-700">
            Current Password
          </label>
          <input
            id="current_password"
            name="current_password"
            type="password"
            required
            value={formData.current_password}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900 placeholder-gray-400 shadow-sm focus:border-customIndigo focus:outline-none focus:ring-1 focus:ring-customIndigo"
          />
        </div>

        <div>
          <label htmlFor="new_password" className="block text-sm font-medium text-gray-700">
            New Password
          </label>
          <input
            id="new_password"
            name="new_password"
            type="password"
            required
            value={formData.new_password}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900 placeholder-gray-400 shadow-sm focus:border-customIndigo focus:outline-none focus:ring-1 focus:ring-customIndigo"
          />
        </div>

        <div>
          <label htmlFor="re_new_password" className="block text-sm font-medium text-gray-700">
            Confirm New Password
          </label>
          <input
            id="re_new_password"
            name="re_new_password"
            type="password"
            required
            value={formData.re_new_password}
            onChange={handleChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900 placeholder-gray-400 shadow-sm focus:border-customIndigo focus:outline-none focus:ring-1 focus:ring-customIndigo"
          />
        </div>

        <div className="pt-4">
          <button
            type="submit"
            disabled={isLoading}
            className={`w-full rounded-md bg-customIndigo px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-customIndigo focus:ring-offset-2 ${
              isLoading ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            {isLoading ? 'Changing Password...' : 'Change Password'}
          </button>
        </div>
      </form>
    </div>
  );
}
